export default __webpack_public_path__ + "static/nguyen-6b1e2e667aa6eb89b2b7efa8b1d7b84a.png";